import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const ThreatFoxAdapterFieldSet = ({
  config,
  handleFormEvent,
  validationMessage,
  validationState
}) => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "include_older_iocs",
      name: "include_older_iocs",
      label: t("threatfox.fields.include_older_iocs"),
      checked: config.include_older_iocs,
      onChange: handleFormEvent,
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "refresh_interval",
      name: "refresh_interval",
      label: t("common.fields.refresh_interval_seconds"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("refresh_interval", t("threatfox.fields.refresh_interval_help")),
      bsStyle: validationState("refresh_interval"),
      value: config.refresh_interval,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: t("common.fields.case_insensitive_lookups"),
      checked: config.case_insensitive_lookup,
      onChange: handleFormEvent,
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
};
export default ThreatFoxAdapterFieldSet;
